import { Button, ButtonGroup, Card, CircularProgress, Grid, Hidden } from '@material-ui/core';
import './wipStyles.scss';

export const EWIPDates = ({ state, classes, WipsDate, array, handleDate, handleChangeByTime, getDateObj, onChartClickHandler }) => {
    return (
        <Grid item container xs={12} sm={12} md={12} lg={12} xl={6} style={{ padding: 5, boxSize: 'none' }}>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <div className="pieChartSize" style={{ display: 'flex' }}>
                        <CircularProgress className="wip-loader" />
                    </div>
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <Hidden only={['xs']}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={8}>
                                <div
                                    style={{
                                        margin: '10px 10px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <ButtonGroup color="secondary" ria-label="outlined primary button group" size="small">
                                        {WipsDate.map((n) => {
                                            return (
                                                <Button
                                                    variant={array.assignedDate === n.id ? 'contained' : 'outlined'}
                                                    onClick={() => handleDate(n.id)}
                                                    style={{ fontSize: 10 }}
                                                >
                                                    {n.name}
                                                </Button>
                                            );
                                        })}
                                    </ButtonGroup>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <div
                                    style={{
                                        float: 'right',
                                        margin: 10
                                    }}
                                >
                                    <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                        <option value={'Default'}>All Branches</option>
                                        {state.chartdata.map((btn, i) => {
                                            return (
                                                <option key={i} value={btn.name}>
                                                    {btn.name}{' '}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>
                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        margin: '0px 20px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">Dates</span>
                                    <select
                                        color="secondary"
                                        onChange={handleDate}
                                        aria-label="outlined primary button group"
                                        size="small"
                                        className="ButtonDropDown"
                                        value={array.assignedDate}
                                    >
                                        {WipsDate.map((n, i) => {
                                            return (
                                                <option key={i} value={n.id}>
                                                    {n.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        margin: '0px 20px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">Branch</span>
                                    <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                        <option value={'Default'}>All Branches</option>
                                        {state.chartdata.map((btn, i) => {
                                            return (
                                                <option key={i} value={btn.name}>
                                                    {btn.name}{' '}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>

                    <div style={{ padding: '0px 30px' }}>
                        <hr className="hr-line" />
                    </div>
                    <Grid container spacing={1} style={{ padding: '0px 20px' }}>
                        {getDateObj.map((item, index) => (
                            <Grid
                                item
                                xs={6}
                                sm={2}
                                style={{ padding: '5px 5px' }}
                                onClick={() =>
                                    onChartClickHandler(
                                        {
                                            workflowID: 'All',
                                            workflow: array.byTimeObj?.workflow,
                                            bn: array.byTimeObj?.bn,
                                            time: item.time,
                                            dueTime: item.dueTime
                                        },
                                        true
                                    )
                                }
                            >
                                <div
                                    style={{
                                        borderLeft: item.BarColor
                                    }}
                                    className="wip-dash-Card-content"
                                >
                                    <div className="wip-dash-Card-content-values">
                                        <span className="lableFont">{item.label}</span>
                                        <div className="valueFont">{item.value}</div>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </Card>
            )}
        </Grid>
    );
};
